"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacialHairColorCode = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FacialHairColorName_1 = __importDefault(require("./FacialHairColorName"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../../AvatarContext"));
function FacialHairColor(_a) {
    var maskID = _a.maskID;
    var color = react_1.useContext(AvatarContext_1.default).facialHairColor;
    return (jsx_runtime_1.jsx("g", __assign({ mask: "url(#" + maskID + ")", fill: getFacialHairColorCode(color) }, { children: jsx_runtime_1.jsx("g", __assign({ transform: 'translate(-32.000000, 0.000000)' }, { children: jsx_runtime_1.jsx("rect", { x: '0', y: '0', width: '264', height: '244' }, void 0) }), void 0) }), void 0));
}
exports.default = FacialHairColor;
function getFacialHairColorCode(color) {
    if (color && color.startsWith('#'))
        return color;
    switch (color) {
        case FacialHairColorName_1.default.Auburn:
            return '#A55728';
        case FacialHairColorName_1.default.Black:
            return '#2C1B18';
        case FacialHairColorName_1.default.Blonde:
            return '#B58143';
        case FacialHairColorName_1.default.BlondeGolden:
            return '#D6B370';
        case FacialHairColorName_1.default.Brown:
            return '#724133';
        case FacialHairColorName_1.default.Platinum:
            return '#ECDCBF';
        case FacialHairColorName_1.default.Red:
            return '#C93305';
        case FacialHairColorName_1.default.BrownDark:
        default:
            return '#4A312C';
    }
}
exports.getFacialHairColorCode = getFacialHairColorCode;
